import getSnapshots from "./defiantSnapshots";
import {performDrugSearch} from "../../../components/drugIndexModal";
import {formatDrugResults} from "./formatter/formatDrugResults";

async function offlineSearchDrug(searchParams) {
    const {
        searchText
    } = searchParams;
    console.log("Performing offline drug search for: ", searchText);

    const {
        guidelinesSnapshot: gSnapshot,
        topicSnapshot: tSnapshot,
    } = await getSnapshots();
    const drugSearchResults = performDrugSearch(searchText, gSnapshot);
    const drugResults = formatDrugResults({
        drugs: drugSearchResults.flattedResults
    }, gSnapshot, tSnapshot);

    return {
        drugResults: drugResults
    };
}

export {
    offlineSearchDrug
};